var exports = {
  "WB": "GroupDMWelcomeSection.module__welcomeSection___eGVxOG",
  "rZ": "GroupDMWelcomeSection.module__profileSection___eGVxOG",
  "hv": "GroupDMWelcomeSection.module__groupName___eGVxOG",
  "Yh": "GroupDMWelcomeSection.module__welcomeText___eGVxOG",
  "o1": "GroupDMWelcomeSection.module__actions___eGVxOG",
};

module.exports = exports;
